import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, retry, shareReplay } from 'rxjs/operators';
import { NavigationItem } from '../models/navigation-item';

import { NavigationItems } from '../models/navigation-items';

const API_ENDPOINT = '/api/game/';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {

  public navigationItems: Observable<NavigationItems> = null;

  // Authenticated routes available while the game is not started yet
  public pregameRoutes: Array<string> = [
    'dashboard',
    'video',
    'tutorial',
    'avatar',
    'content',
    'contact',
    'profile',
  ];

  /**
   * The Constructor for this component.
   *
   * @param {HttpClient} http
   */
  public constructor(private http: HttpClient) {
  }

  /**
   * Gets the navigation items.
   *
   * @return {Observable<NavigationItems>}
   */
  public getActiveNavigationItems(): Observable<NavigationItems> {
    if (!this.navigationItems) {
      this.navigationItems = this.loadActiveNavigationItems().pipe(
        shareReplay(1),
      );
    }

    return this.navigationItems;
  }

  /**
   * Loads the active navigation items for the current game.
   * This is both for the modules and the default navigation.
   *
   * @returns void
   */
  public loadActiveNavigationItems(): Observable<any> {
    return this.http.get(API_ENDPOINT + 'get/navigation')
    .pipe(
      retry(3),
      map(
        (response: { items: { default: NavigationItem[], modules: NavigationItem[] } }) => {
          const navigationItems = new NavigationItems;
          navigationItems.defaultItems = response.items.default;
          navigationItems.moduleItems = response.items.modules;
          return navigationItems;
        },
      ),
    );
  }
}
